import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { get } from 'lodash'
import { Box, CircularProgress, Typography, Divider } from '@material-ui/core'

import { ErrorBoundary } from '@scoir/error-reporter'

import api from 'common/api'
import { actions as snactions } from 'store/snackbar'
import useTitle from 'common/use-title'

import UserTypeMessageSection from './UserTypeMessageSection'
import { EditContextWrapper, ComposeContextWrapper, ComposeActionTrigger } from './components/ComposeEditModal'

import { OUTREACH_MESSAGE_TYPES } from '../outreach-message-types'
import { formatMessages } from './helpers'

export const OutreachMessages = ({ currentRouteEndpoint, scid }) => {
  useTitle('Scoir - Messaging')
  const [loading, setLoading] = useState(true)
  const [messages, setMessages] = useState([])
  const [hasMessages, setHasMessages] = useState(false)
  const [messageCount, setMessageCount] = useState(0)
  const config = get(OUTREACH_MESSAGE_TYPES, currentRouteEndpoint, {})

  const getMessages = useCallback(
    (showLoading = false) => {
      setLoading(showLoading)
      return api
        .get(`/api/college/${scid}/message`)
        .then((res) => {
          const { messages, hasMessages, messageCount } = formatMessages(res, config.trigger)
          setMessages(messages)
          setHasMessages(hasMessages)
          setMessageCount(messageCount)
          setLoading(false)
        })
        .catch(() => {
          snactions.addSnackbarItem('An error occurred while fetching messages.')
          setLoading(false)
        })
    },
    [scid, config],
  )

  useEffect(() => {
    getMessages(true)
  }, [currentRouteEndpoint, getMessages])

  return (
    <Box>
      <ErrorBoundary>
        <Box
          display="flex"
          justifyContent="space-between"
          py={3}
          px={2}
        >
          <Box>
            <Typography
              variant="body1"
              color="textPrimary"
            >
              {messageCount} {config.title} Message{messageCount !== 1 && 's'}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              {config.description}
            </Typography>
          </Box>
          <Box alignSelf="center">
            <ComposeContextWrapper onSave={getMessages}>
              <ComposeActionTrigger trigger={config.trigger} />
            </ComposeContextWrapper>
          </Box>
        </Box>
        <Divider light />
        <Box
          minHeight="560px"
          px={{ xs: 1, sm: 2 }}
          py={0}
        >
          {loading ? (
            <Box
              p={8}
              textAlign="center"
            >
              <CircularProgress
                aria-label="Loading"
                role="status"
                size="50px"
              />
            </Box>
          ) : (
            <EditContextWrapper onSave={getMessages}>
              <UserTypeMessageSection
                messages={messages}
                hasMessages={hasMessages}
                getMessages={getMessages}
              />
            </EditContextWrapper>
          )}
        </Box>
      </ErrorBoundary>
    </Box>
  )
}

OutreachMessages.propTypes = {
  currentRouteEndpoint: PropTypes.string.isRequired,
  scid: PropTypes.number.isRequired,
}

export default connect((store) => ({
  scid: store.college.record.Scid,
}))(OutreachMessages)
